"use client";

import * as React from "react";
import { fetchCrossdAprPercent } from "../../wallet-info/queries/use-crossd-apr";

export function useGetOneUsdApr(enabled: boolean): number | null {
  const [aprPercent, setAprPercent] = React.useState<number | null>(null);

  React.useEffect(() => {
    if (!enabled) return;
    let alive = true;
    void fetchCrossdAprPercent()
      .then((value) => {
        if (alive) setAprPercent(value);
      })
      .catch(() => {
        // APR is supporting information; the Get ONEUSD action remains usable.
      });
    return () => {
      alive = false;
    };
  }, [enabled]);

  return aprPercent;
}
